import React from 'react';
import './Footer.css';
import { FaFacebook, FaTiktok, FaInstagram, FaLinkedin } from 'react-icons/fa'; // Importation des icônes

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <p>&copy; {new Date().getFullYear()} CASPH ROYAL. Tous droits réservés.</p>
          </div>

          <div className="col-md-6 text-center text-md-end">
            <ul className="social-icons">
              <li>
                <a href="https://www.facebook.com/61570320854053" target="_blank" rel="noopener noreferrer">
                  <FaFacebook /> {/* Remplacement de l'icône Facebook */}
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@casphroyal" target="_blank" rel="noopener noreferrer">
                  <FaTiktok /> {/* Remplacement de l'icône TikTok */}
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/casphroyal" target="_blank" rel="noopener noreferrer">
                  <FaInstagram /> {/* Remplacement de l'icône Instagram */}
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/casphroyal" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin /> {/* Remplacement de l'icône LinkedIn */}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
